

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;




//////////////////
// WEBPACK FOOTER
// ../node_modules/call-bind-apply-helpers/functionCall.js
// module id = ../node_modules/call-bind-apply-helpers/functionCall.js
// module chunks = 1